"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.number.constructor");















var _taskSkill = _interopRequireDefault(require("./taskSkill"));
var _taskSkillParams = _interopRequireDefault(require("./taskSkillParams")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { name: 'TaskSkillLayout', components: { TaskSkill: _taskSkill.default, TaskSkillParams: _taskSkillParams.default }, props: { taskId: { type: Number }, flowId: { type: Number } }, data: function data() {
    return {
      params: [] };

  },
  mounted: function mounted() {
    console.log('l->task:' + this.taskId);
  },
  methods: {
    handleGetSkillData: function handleGetSkillData(taskId, flowId) {
      console.log('getSkill->' + taskId + ',' + flowId);
      var self = this;
      if (self.$refs['taskSkill']) {
        console.log('getSkillSkill');
        self.$refs.taskSkill.handleGetData(taskId, flowId);
      }
    },
    handleGetParams: function handleGetParams(params) {
      console.log('handleGet');
      this.$refs.skillParams.handleGetParams(params);
    },
    handleClearParams: function handleClearParams() {
      var self = this;
      console.log('lll-clear');
      if (self.$refs.skillParams) {
        console.log('l-clear');
        self.$refs.skillParams.handleClearParams();
      }
    } } };exports.default = _default;